export const ANALYTICS_CONSENT_STORAGE_KEY = "promoamp_analytics_consent"
export const ANALYTICS_CONSENT_EVENT = "promoamp:analytics-consent"
export const OPEN_PRIVACY_CHOICES_EVENT = "promoamp:open-privacy-choices"

export type AnalyticsConsent = "granted" | "denied"

export function browserPrivacySignalIsEnabled() {
  if (typeof navigator === "undefined") return false

  const navigatorWithPrivacy = navigator as Navigator & {
    globalPrivacyControl?: boolean
  }

  return (
    navigatorWithPrivacy.globalPrivacyControl === true ||
    navigator.doNotTrack === "1"
  )
}

export function getAnalyticsConsent(): AnalyticsConsent | null {
  if (typeof window === "undefined") return null
  if (browserPrivacySignalIsEnabled()) return "denied"

  try {
    const storedValue = localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)
    return storedValue === "granted" || storedValue === "denied"
      ? storedValue
      : null
  } catch {
    return null
  }
}

export function setAnalyticsConsent(consent: AnalyticsConsent) {
  if (typeof window === "undefined") return

  try {
    localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent)
  } catch {
    // The current page can still honour the visitor's choice in memory.
  }

  window.dispatchEvent(
    new CustomEvent<AnalyticsConsent>(ANALYTICS_CONSENT_EVENT, {
      detail: consent,
    }),
  )
}
